export default [
  {
    id: 'Total Balance',
    data: [
      {
        x: '2020-02-28',
        y: 329334302,
      },
      {
        x: '2020-02-28',
        y: 370429198,
      },
      {
        x: '2020-02-21',
        y: 329334302,
      },
      {
        x: '2020-02-14',
        y: 318078347,
      },
      {
        x: '2020-02-07',
        y: 283721137,
      },
      {
        x: '2020-01-31',
        y: 291082564,
      },
      {
        x: '2020-01-24',
        y: 319642636,
      },
      {
        x: '2020-01-17',
        y: 329950082,
      },
      {
        x: '2020-01-10',
        y: 349097522,
      },
      {
        x: '2020-01-03',
        y: 327310389,
      },
      {
        x: '2019-12-31',
        y: 341472660,
      },
      {
        x: '2019-12-27',
        y: 335820964,
      },
      {
        x: '2019-12-20',
        y: 356424766,
      },
      {
        x: '2019-12-13',
        y: 358092486,
      },
      {
        x: '2019-12-06',
        y: 356926098,
      },
      {
        x: '2019-11-29',
        y: 350946234,
      },
      {
        x: '2019-11-22',
        y: 352170699,
      },
      {
        x: '2019-11-15',
        y: 355307050,
      },
      {
        x: '2019-11-08',
        y: 356367314,
      },
      {
        x: '2019-11-01',
        y: 347350054,
      },
      {
        x: '2019-10-25',
        y: 357686828,
      },
      {
        x: '2019-10-18',
        y: 387434298,
      },
      {
        x: '2019-10-11',
        y: 390308713,
      },
      {
        x: '2019-10-07',
        y: 386366113,
      },
      {
        x: '2019-09-27',
        y: 409895155,
      },
      {
        x: '2019-09-20',
        y: 374646015,
      },
      {
        x: '2019-09-13',
        y: 435167150,
      },
      {
        x: '2019-09-06',
        y: 357605121,
      },
      {
        x: '2019-08-30',
        y: 349520354,
      },
      {
        x: '2019-08-23',
        y: 374957544,
      },
      {
        x: '2019-08-16',
        y: 357282784,
      },
      {
        x: '2019-08-09',
        y: 367553771,
      },
      {
        x: '2019-08-01',
        y: 379856262,
      },
      {
        x: '2019-07-31',
        y: 364413659,
      },
      {
        x: '2019-07-26',
        y: 382217331,
      },
      {
        x: '2019-07-19',
        y: 388509582,
      },
      {
        x: '2019-07-12',
        y: 431336126,
      },
      {
        x: '2019-07-05',
        y: 390854886,
      },
      {
        x: '2019-06-28',
        y: 384326981,
      },
      {
        x: '2019-06-21',
        y: 389401582,
      },
      {
        x: '2019-06-14',
        y: 392376865,
      },
      {
        x: '2019-06-07',
        y: 393363507,
      },
      {
        x: '2019-05-31',
        y: 393944929,
      },
      {
        x: '2019-05-24',
        y: 390074165,
      },
      {
        x: '2019-05-17',
        y: 394083141,
      },
      {
        x: '2019-05-10',
        y: 368499963,
      },
      {
        x: '2019-05-03',
        y: 362353152,
      },
      {
        x: '2019-04-26',
        y: 363644911,
      },
      {
        x: '2019-04-18',
        y: 372835961,
      },
      {
        x: '2019-04-12',
        y: 380856739,
      },
      {
        x: '2019-04-05',
        y: 382479206,
      },
      {
        x: '2019-03-31',
        y: 377067138,
      },
      {
        x: '2019-03-22',
        y: 357819238,
      },
      {
        x: '2019-03-05',
        y: 359785335,
      },
      {
        x: '2019-03-01',
        y: 351804800,
      },
      {
        x: '2019-02-22',
        y: 343716666,
      },
      {
        x: '2019-02-08',
        y: 350064165,
      },
      {
        x: '2019-01-31',
        y: 340724239,
      },
      {
        x: '2019-01-24',
        y: 352784550,
      },
    ],
  },
];
